import { Select, Table } from 'antd';
import './settings-page.scss';
import { Link } from 'react-router-dom';
import { ROUTER_PATHS } from 'routes/routerConstants';
import { getRoles, getUsers, updateRoles } from 'actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { hasPermission } from 'utils';

const SettingsPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUsers());
    dispatch(getRoles());
  }, []);

  const { user } = useSelector((store) => store);

  const [data, setData] = useState([]);

  useEffect(() => {
    setData(user?.users || []);
  }, [user]);

  const handleChange = (value, recordKey) => {
    setData((prev) =>
      prev.map((row) => (row.id === recordKey ? { ...row, roles: value } : row))
    );
    dispatch(updateRoles(value, recordKey));
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: ['name'],
      key: 'name',
      width: 300
    },
    /* {
      title: 'Member since',
      dataIndex: ['created_at'],
      key: 'created_at'
    }, */
    {
      title: 'Status',
      dataIndex: ['status'],
      key: 'status',
      width: 200
    },
    {
      title: 'Role',
      dataIndex: ['roles'],
      key: 'roles',
      width: 400,
      render: (roles, record) => {
        // const { roles } = record;
        return (
          <Select
            mode="multiple"
            value={roles}
            style={{ width: '100%' }}
            onChange={(value) => {
              // console.log(value);
              handleChange(value, record.key);
            }}
            disabled={!hasPermission('settings.write')}
          >
            {(user?.all_roles || []).map((role) => (
              <Select.Option key={role.id} value={role.id}>
                {role.attributes.name}
              </Select.Option>
            ))}
          </Select>
        );
      }
    }
  ];

  // console.log(data);

  return (
    <div className="settings-page-container">
      <div className="left-menu">
        <Link to={ROUTER_PATHS.SETTINGS}>Permissions</Link>
      </div>
      <div className="content">
        <h1>Permissions</h1>
        <div>
          <Table
            dataSource={(data || []).map((source) => ({
              key: source.id,
              name: source.name,
              created_at: source.created_at,
              status: source.status ? 'Active' : 'Inactive',
              roles: source.roles,
              role_names: source.role_names
            }))}
            columns={columns}
            bordered
            pagination={{ pageSize: 8 }}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
